<template>
	<el-table
		:data="items"
		height="250"
		border
		show-summary
		size="mini"
		style="width: 100%"
		v-if="hasGetTableDataModel"
		@selection-change="handleSelectionChange"
	>
		<el-table-column type="selection" v-if="checkable"></el-table-column>
		<el-table-column type="index" :index="1"></el-table-column>
		<el-table-column
			:prop="key.name"
			:label="dataModels.Order_item[key.name].show_name"
			:sortable="key.sortable"
			:key="index"
			:width="key.width"
			v-for="(key,index) in itemFields"
		>
			<div slot-scope="scope">
				<span v-if="key.isOnlyShow && key.render" v-html="key.render(scope.row)"></span>
				<field-show
					:field-info="dataModels.Order_item[key.name]"
					:value="scope.row[key.name]"
					:field-key="key"
					v-else-if="key.isOnlyShow"
				></field-show>
				<field-editor
					:width="key.width"
					:tips="key.tips"
					v-model="scope.row[key.name]"
					:field-info="dataModels.Order_item[key.name]"
					:record-id="recordId"
					record-model="Order_item"
					@change="onChange(scope.$index)"
					:params="key.params"
					v-else
				></field-editor>
			</div>
		</el-table-column>
		<el-table-column fixed="right" label="操作">
			<template slot-scope="scope">
				<el-button @click="handleRemove(scope.$index)" type="text" size="small">
					<i class="el-icon-delete"></i>
				</el-button>
			</template>
		</el-table-column>
	</el-table>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
	data() {
		return {
			loadings: {
				main: false,
				create: false,
				insert: false,
			},
			recordId: "",
			itemFields: [
				{
					name: "brand_show_id",
					isOnlyShow: true,
				},
				{
					name: "brand",
					isOnlyShow: true,
				},
				{
					name: "product_color",
					isOnlyShow: true,
					width: "200px",
				},
				{
					name: "model",
					isOnlyShow: true,
				},
				{
					name: "price_per",
				},
				{
					name: "amount",
				},
				{
					name: "total_price",
					isOnlyShow: true,
				},
			],
		};
	},
	computed: {
		...mapState(["dataModels", "loadingDM"]),
		items: {
			get: function() {
				return this.value;
			},
			set: function(newValue) {
				this.$emit("input", newValue);
				this.$emit("change", newValue);
			},
		},
		hasGetTableDataModel() {
			if (this.dataModels["Order_item"] && this.dataModels["Order_item"]._id) {
				return true;
			} else {
				return false;
			}
		},
	},
	props: {
		value: {
			type: Array,
			default: function() {
				return [];
			},
		},
		checkable: {
			type: Boolean,
			default: false,
		},
		itemData:{
			type:Array,
			default: function() {
				return [];
			},
		}
	},
	methods: {
		doResetAll() {
			this.items = [];
		},
		handleRemove(index) {
			this.items.splice(index, 1);
		},
		onChange(index) {
			this.items[index].total_price = (
				this.items[index].price_per * this.items[index].amount
			).toFixed(2);
		},
		handleSelectionChange(val) {
			let idMapping = {};
			val.forEach(item => {
				idMapping[item._id] = 1;
			});
			this.items.forEach(item => {
				if (idMapping[item._id]) {
					item.checked = true;
				} else {
					item.checked = false;
				}
			});
			this.$emit("select", this.items);
		},
	},
	watch:{
		itemData(val){

			this.items = val
			console.log('复制后this.items', this.items)
			this.$emit("select", this.items);
		}
	}
};
</script>
<style lang="scss" scoped>
</style>
